import { jsx as _jsx } from "react/jsx-runtime";
import { FoodGoodsCard as FoodGoodsItem } from '../../common/components';
import { useMobile } from '../../common/hooks/use-mobile';
import { transformInterval, transformPageMargins } from '../../common/utils';
import { classNames } from '../../common/utils/classnames';
import { get } from 'lodash-es';
export var FoodGoodsCard = function FoodGoodsCard(_ref) {
  var goodsList = _ref.goodsList,
    goodsGap = _ref.goodsGap,
    pagePadding = _ref.pagePadding,
    dataset = _ref.dataset,
    onAddCart = _ref.onAddCart,
    onCollect = _ref.onCollect;
  var mobile = useMobile();
  var displayGoodsList = get(dataset, 'data', goodsList) || [];
  return _jsx("div", Object.assign({
    className: 'container'
  }, {
    children: _jsx("div", Object.assign({
      className: classNames('grid grid-cols-2 w-full', 'cq-pc:grid-cols-6'),
      style: {
        paddingLeft: transformPageMargins(pagePadding, mobile),
        paddingRight: transformPageMargins(pagePadding, mobile),
        gap: transformInterval(goodsGap, mobile, 'proudcCard')
      }
    }, {
      children: displayGoodsList.map(function (goods) {
        return _jsx(FoodGoodsItem, {
          className: 'col-span-1',
          goods: goods,
          onAddCart: onAddCart,
          onCollect: onCollect
        }, goods.csku);
      })
    }))
  }));
};